import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const TrashFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M18.1 4.25H15.75V4C15.75 2.48 14.52 1.25 13 1.25H11C9.48 1.25 8.25 2.48 8.25 4V4.25H6C4.48 4.25 3.25 5.48 3.25 7V8.25C3.25 8.66 3.59 9 4 9H20.1C20.51 9 20.85 8.66 20.85 8.25V7C20.85 5.48 19.62 4.25 18.1 4.25ZM14.25 4.25H9.75V4C9.75 3.31 10.31 2.75 11 2.75H13C13.69 2.75 14.25 3.31 14.25 4V4.25Z"
        fill={color}
      />
      <path
        d="M5.15 20.1C5.15 21.54 6.41 22.75 7.9 22.75H16.2C17.61 22.75 18.81 21.62 18.95 20.16L19.73 10.5H4.37L5.15 20.1ZM13.25 13.5C13.25 13.09 13.59 12.75 14 12.75C14.41 12.75 14.75 13.09 14.75 13.5V19C14.75 19.41 14.41 19.75 14 19.75C13.59 19.75 13.25 19.41 13.25 19V13.5ZM9.25 13.5C9.25 13.09 9.59 12.75 10 12.75C10.41 12.75 10.75 13.09 10.75 13.5V19C10.75 19.41 10.41 19.75 10 19.75C9.59 19.75 9.25 19.41 9.25 19V13.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TrashFilledIcon.displayName = 'TrashFilledIcon';
